/* oxlint-disable react/rules-of-hooks -- Existing hook usage is preserved during the linter migration. */
/* oxlint-disable react/react-compiler -- Existing code is not yet compatible with React Compiler checks. */
import * as React from 'react';

/**
 * Same thing as useLayoutEffect but doesn't print a warning when used during SSR.
 */
export function useSafeLayoutEffect(
    effect: React.EffectCallback,
    deps?: React.DependencyList
): void {
    if (typeof window !== 'undefined') {
        React.useLayoutEffect(effect, deps);
    }
}
